module.exports = __webpack_public_path__ + "img/btn_OCR_normal.5993466a.png";